'use strict';
import getEnvironment from 'core_modules/bootstrap/environments/get-environment';
import { getParameterByName } from 'service_modules/utils/window-get-param';

export default class PznPageIdleMonitor {
  constructor(data) {
    const isEnvProd = getEnvironment() === 'E3';

    let { interval, expiryHandler, minutesBeforeExpiration } = data;

    this.interval = interval || 5000;

    if (isEnvProd === true) {
      this.minutesBeforeExpiration = minutesBeforeExpiration || 20;
    } else {
      let expiryMinutesFromURL = getParameterByName('pznexpirationminutes');
      let numUrlMinutes = parseInt(expiryMinutesFromURL, 10);

      if (isNaN(numUrlMinutes)) {
        this.minutesBeforeExpiration = minutesBeforeExpiration || 20;
      } else {
        numUrlMinutes = numUrlMinutes > 20 ? 20 : numUrlMinutes;
        numUrlMinutes = numUrlMinutes < 1 ? 1 : numUrlMinutes;
        this.minutesBeforeExpiration = numUrlMinutes;
      }
    }

    this.expiryHandler = expiryHandler || function() {};
    this.intervalHandle = null;
    this.baseDate = new Date();
  }

  hasExpired() {
    const diffMilliSec = new Date().getTime() - this.baseDate.getTime();
    const minVal = Math.round(((diffMilliSec % 86400000) % 3600000) / 60000);
    return minVal >= this.minutesBeforeExpiration;
  }

  monitor = domEvent => {
    const eleObj = domEvent.target;
    if (eleObj && String(eleObj.tagName).toLowerCase() === 'a' && eleObj.href) {
      this.baseDate = new Date();
    }
  };

  setup() {
    this.baseDate = new Date();

    document.getElementsByTagName('body')[0].addEventListener('click', this.monitor);
  }

  cleanUp() {
    document
      .getElementsByTagName('body')[0]
      .removeEventListener('click', this.monitor);
  }

  start() {
    let self = this;
    self.setup();

    self.intervalHandle = window.setInterval(() => {
      if (self.hasExpired()) {
        self.stop();
        self.expiryHandler();
      }
    }, self.interval);
  }

  stop() {
    if (this.intervalHandle) {
      window.clearInterval(this.intervalHandle);
    }
    this.cleanUp();
  }
}
